package com.wintermar.inspection

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import com.wintermar.inspection.di.initKoin
import com.wintermar.inspection.navigation.Route
import com.wintermar.inspection.navigation.RoutePath
import kotlinx.browser.window

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    initKoin()
    ComposeViewport {
        // window.location.hash returns example: "#/inspection"
        val initialPath = window.location.hash.removePrefix("#")
        val initialRoute =  when {
            initialPath.startsWith(RoutePath.INSPECTION.path) -> Route.Inspection
            initialPath.startsWith(RoutePath.TEMPLATE.path) -> Route.Template
            else -> Route.NotFound
        }
        App(initialRoute)
    }
}
